var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m409.1 468.69-33.1 10.36-28.6 8.95h-150.21l-29.19-93.26-96-306.74 96-30.05 102.5-32.08 105.5 337.07z",
    fill: "#379a6b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m338.929 431.973 7.168 22.904-91.617 28.675-7.169-22.905-22.904 7.169-105.141-335.931 22.904-7.168-7.168-22.905 91.617-28.674 7.169 22.904 22.904-7.169 105.141 335.931z",
    fill: "#44c086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m168 24h208v464h-208z",
    fill: "#3ba673"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m320 432v24h-96v-24h-24v-352h24v-24h96v24h24v352z",
    fill: "#44c086"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 256,
    fill: "#3ba673",
    r: 40
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m440 296v192h-56a80 80 0 0 1 -80-80h.16l-51.9-76.805a32 32 0 0 1 8.6-44.43 32 32 0 0 1 44.43 8.6l46.71 64.635h24v-192l60.235 112.941a32 32 0 0 1 3.765 15.059z",
    fill: "#f5cbaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyFlat);
export default __webpack_public_path__ + "static/media/money-flat.c14e603d012f2c4be16c7be57dc99934.svg";
export { ForwardRef as ReactComponent };